import { Container, Graphics } from 'pixi.js';
import type { TeamSpec } from '../sim/teams';
import { CAR_LENGTH, CAR_WIDTH } from '../sim/tuning';

/** Top-down greybox F1 car, nose pointing +x. Origin = car centre. */
export function buildCar(team: TeamSpec, alpha = 1): Container {
  const c = new Container();
  const g = new Graphics();
  const L = CAR_LENGTH;
  const W = CAR_WIDTH;
  const tyre = 0x141414;
  // Tyres (fat rears, slimmer fronts).
  g.roundRect(-L / 2 + 1, -W / 2 - 2.5, 5.5, 3.5, 1).fill(tyre);
  g.roundRect(-L / 2 + 1, W / 2 - 1, 5.5, 3.5, 1).fill(tyre);
  g.roundRect(L / 2 - 7, -W / 2 - 2, 4.5, 3, 1).fill(tyre);
  g.roundRect(L / 2 - 7, W / 2 - 1, 4.5, 3, 1).fill(tyre);
  // Rear wing (dark, so you can always tell which way a car points),
  // body, pointed nose cone, front wing in the team's second colour.
  g.rect(-L / 2 - 1.5, -W / 2 + 0.5, 3, W - 1).fill(0x1a1a1a);
  g.rect(-L / 2 - 1, -1, 2, 2).fill(team.secondary);
  g.roundRect(-L / 2 + 1.5, -W / 4 - 0.5, L - 6, W / 2 + 1, 2).fill(team.primary);
  g.poly([L / 2 - 5, -1.8, L / 2 + 3, -0.6, L / 2 + 3, 0.6, L / 2 - 5, 1.8]).fill(team.primary);
  g.rect(L / 2 - 0.5, -W / 2 + 1, 1.6, W - 2).fill(team.secondary);
  // Side pods stripe + helmet.
  g.rect(-L / 2 + 4, -W / 4 - 0.5, L - 11, 1.2).fill(team.secondary);
  g.circle(0.5, 0, 1.6).fill(0xffd84a);
  c.addChild(g);
  c.alpha = alpha;
  return c;
}
